import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import SimpleCta from 'components/simple-cta'
import WidgetPage from 'components/hocs/widget-page'

const variations = {
  'compare-mortgage-rates': 'Compare Lender Options',
  'learn-about-mortgage-rates': 'Learn About Lender Options',
  'learn-about-mortgage-refi': 'Learn About Mortgage Refi',
  'learn-about-home-loans': 'Learn About Home Loans',
  'compare-rates': 'Get Started',
  'find-my-rate': 'Find My Lender',
  'learn-more': 'Learn More',
}
export const SimpleCtaApp = (props) => {
  const { variation, customCTA, uniqueId } = props

  const url =
    variation === 'compare-rates'
      ? `${config.credibleRoot}/mortgage/rates/landing`
      : `${config.credibleRoot}/mortgage`

  return (
    <SimpleCta
      nmls
      url={url}
      variations={variations}
      customCTA={customCTA}
      uniqueId={uniqueId}
      large={variations[variation]?.length > 20}
      {...props}
    />
  )
}

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
  uniqueId: PropTypes.string.isRequired,
  customCTA: PropTypes.string,
}

export default WidgetPage(SimpleCtaApp)
